import { choose } from '../../utils/platform';
import UserEditFormDesktop from './UserEditForm.desktop';
import UserEditFormMobile from './UserEditForm.mobile';

// Platform chooser: the APK renders the mobile variant, any browser the desktop one.
export default choose(UserEditFormDesktop, UserEditFormMobile);
